const capitalize = (str: string): string =>
  str
    .toLowerCase()
    .replace(
      /(^|[\s-])([A-Za-zÀ-ÖØ-öø-ÿ])/g,
      (_, $1, $2) => $1 + $2.toUpperCase(),
    );

export default capitalize;
